import type { PartialStoreState } from '../typings'

export const selectRegions = (state: PartialStoreState) => state.domain.publicData.domain.rm.regions
